module.exports = __webpack_public_path__ + "img/2323.0f7b33f.jpg";